import React from 'react';
import EstadoContableReport from './EstadoContableReport';

const EstadoResultados: React.FC = () => <EstadoContableReport reportType="resultados" />;

export default EstadoResultados;
